var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPushCircle = function SvgPushCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11,
    fill: "#D05FD7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M17 16H7V15H7.5V11.5155C7.5 9.0215 9.515 7 12 7C14.485 7 16.5 9.0215 16.5 11.5155V15H17V16ZM8.5 15H15.5V11.5155C15.5 9.574 13.933 8 12 8C10.067 8 8.5 9.574 8.5 11.5155V15ZM10.75 16.5H13.25C13.25 16.8315 13.1183 17.1495 12.8839 17.3839C12.6495 17.6183 12.3315 17.75 12 17.75C11.6685 17.75 11.3505 17.6183 11.1161 17.3839C10.8817 17.1495 10.75 16.8315 10.75 16.5Z"
  })));
};
export default SvgPushCircle;